import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import "../styles/roomSelection.css";
import { createRoom, joinRoom } from "../api/room";

function RoomSelectionPage() {
  const navigate = useNavigate();

  const handleCreateRoom = () => {
    createRoom().then((data) => {
      Cookies.set("roomId", data.roomId);
      Cookies.set("roomCode", data.roomCode);
      navigate("/game");
    });
  };

  const handleJoinRoom = () => {
    let roomCode = window.prompt("Enter room code");
    roomCode = roomCode.trim().toUpperCase();
    joinRoom(roomCode).then((data) => {
      Cookies.set("roomId", data.roomId);
      Cookies.set("roomCode", data.roomCode);
      navigate("/game");
    });
  };

  const handleLogout = () => {
    Cookies.remove("token");
    Cookies.remove("roomId");
    Cookies.remove("roomCode");
    navigate("/");
  };

  useEffect(() => {
    const token = Cookies.get("token");
    if (!token) {
      navigate("/");
    }
  }, [navigate]);

  return (
    <div className="room-selection-container">
      <h2>Choose an Option</h2>
      <button onClick={handleCreateRoom}>Create Room</button>
      <button onClick={handleJoinRoom}>Join Room</button>
      <button className="logout-button" onClick={handleLogout}>
        Logout
      </button>
    </div>
  );
}

export default RoomSelectionPage;
